//@ts-check
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';

import { contentLoaded } from '../../../utils/document-promises';
import { ApolloProvider, InMemoryCache } from '@apollo/client';
import { createApolloClientWithCache } from '../../../templates/_shared/apolloClientUtils';
import MobileNav from './MobileNav';
import SearchMobileNav from './SearchMobileNav';
import { globalWindow } from '../../../utils/constants';

const mobileNavCache = new InMemoryCache({
  typePolicies: {
    Product: {
      keyFields: ['metafield', ['value', 'id']],
    },
  },
});

const client = createApolloClientWithCache(mobileNavCache);

export const initSearchBurgerMenu = async () => {
  await contentLoaded;
  try {
    const mobileMenuTarget = document.querySelector(
      '[react-render-target="mobile-navbar-row"][on-shop-navigation] [react-render-target="mobile-nav-menu-drawer"]'
    );
    const tabletMenuTarget = document.querySelector(`[react-render-target="search-burger-tablet"]`);
    const mobileSearchTarget = document.querySelector('[react-render-target="mobile-search"]');

    //@ts-expect-error // ? [REVISIT]
    const render = (Component, target) => {
      // ? [REVISIT] do this w/ Portals
      // ! ... alternatively what about tablet only? (which is funtionally the same on mobile?)
      // -- additionally we can remove a lot of other "hacky" code to determine height etc.?
      // -- // ! [REVISIT] if we go down this route we need to make the sure the APP's width is not capped?
      const component = <Component />;
      ReactDOM.render(
        <StrictMode>
          <ApolloProvider client={client}>{component}</ApolloProvider>
        </StrictMode>,
        target
      );
    };
    if (mobileMenuTarget) render(MobileNav, mobileMenuTarget);
    if (tabletMenuTarget) render(MobileNav, tabletMenuTarget);
    if (mobileSearchTarget) render(SearchMobileNav, mobileSearchTarget);

    const setMobileNav =
      //@ts-expect-error // ? [REVISIT]
      (setMobileNavData) => {
        globalWindow.dispatchEvent(new CustomEvent('SetMobileNav', { detail: setMobileNavData }));
      };
    globalWindow.setMobileNav = setMobileNav;
    globalWindow.openMenu =
      //@ts-expect-error // ? [REVISIT]
      (l1CategoryName) => setMobileNav({ open: true, categoryPath: [l1CategoryName] });

    // HMR
    if (process.env.NODE_ENV === 'development' && module?.hot) {
      module.hot.accept();
    }
  } catch (err) {
    console.error('Failed to load SearchBurgerMenu');
    console.error(err);
  }
};
